/** @internal */
export function isVersionedTransaction(transaction) {
    return 'version' in transaction;
}
//# sourceMappingURL=transaction.js.map